export const TEST_ENVIRONMENT = false;
export const PIXEL_RATIO = window.devicePixelRatio || 1;
export const VIEWPORT_RATIO = 0.98;
export const API_DOMAIN = 'https://manager.dotag.com';
export const STRIPE_KEY = 'pk_test_51HwQqvAGt1rrMKDLoTukMXTNPuahGRq1887m6jHue44pc8qLLrs1N0o6v0IYrabXg8YYtGgeMhmzsz72hpvJiZwu00IrbBPfGL';
export const STORAGE_DIR = 'file:///data/user/0/fi.premode.dotagmobile/files/'; // Should be removed
export const MAX_WIDTH = 2048;
export const MAX_HEIGHT = 2048;
